
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2xONu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3d3WW = parcelRequire("3d3WW");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $lLRfG = parcelRequire("lLRfG");


var $ZugQS = parcelRequire("ZugQS");


var $6VdZc = parcelRequire("6VdZc");


var $1NBp8 = parcelRequire("1NBp8");


var $kJNMt = parcelRequire("kJNMt");


var $9eE57 = parcelRequire("9eE57");


var $dPJCf = parcelRequire("dPJCf");


var $1UCmC = parcelRequire("1UCmC");


var $6mKj3 = parcelRequire("6mKj3");


var $gkVDU = parcelRequire("gkVDU");





var $9DHhW = parcelRequire("9DHhW");


var $56QzY = parcelRequire("56QzY");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $ktNBJ = parcelRequire("ktNBJ");


var $01STT = parcelRequire("01STT");


var $c8cx7 = parcelRequire("c8cx7");

const $ed354f3152b56d9c$export$47c3b27230c0b07f = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const selectedView = (0, $ktNBJ.useSelectedView)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: `${selectedView}Screen`,
                source: 'homeScreen',
                attributes: {
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            }
        }).fire();
    }, [
        selectedView,
        createAnalyticsEvent
    ]);
    switch(selectedView){
        case (0, $01STT.View).RECENT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c8cx7.Recent), null);
        case (0, $01STT.View).STARRED:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c8cx7.Starred), null);
        case (0, $01STT.View).DRAFTS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c8cx7.Drafts), null);
        case (0, $01STT.View).TASKS:
            /**
       * We don't want the task home experience to impact Home. This will consider the Home experience as complete
       * for the purposes of the loading indicator underneath the main navigation bar.
       */ experienceTracker.succeed({
                name: (0, $irVI7.HOME_EXPERIENCE)
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c8cx7.Tasks), null);
        case (0, $01STT.View).OVERVIEW:
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c8cx7.ForYou), null);
    }
};


parcelRequire("c8cx7");
var $edxGF = parcelRequire("edxGF");











var $gykrH = parcelRequire("gykrH");

const $e1febe16f9c86232$export$db81afc2ba5d3f3b = ()=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [homeReadyForUser, setHomeReadyForUser] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (experienceTracker.getExperienceState((0, $irVI7.HOME_EXPERIENCE))?.hasStopped) setHomeReadyForUser(true);
        return experienceTracker.subscribe((event)=>{
            if (event.name === (0, $irVI7.HOME_EXPERIENCE) && (0, $gykrH.isStop)(event)) setHomeReadyForUser(true);
        });
    }, [
        experienceTracker
    ]);
    return homeReadyForUser;
};











const $f5f4d7bca1e6438a$export$26530c4be93733fa = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'home',
                source: 'homeScreen',
                attributes: {
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
};



var $jln20 = parcelRequire("jln20");

const $86e12f8c87d0ed6d$export$99e818ef77d5eb01 = ()=>{
    const { sidebars: sidebars } = (0, $jln20.useRightSidebarContext)();
    return sidebars.reduce((accumulator, sidebar)=>{
        if (sidebar.isCollapsed || sidebar.isMinimized) return accumulator;
        return accumulator + sidebar.width;
    }, 0);
};


const $1e2600c970f9c7ad$export$9ab51c7cc93666ed = 1151;









var $hGNbF = parcelRequire("hGNbF");

function $a79337c1b0b1c1d5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a79337c1b0b1c1d5$var$pageLoadMetricLookup = {
    [(0, $01STT.View).OVERVIEW]: undefined,
    //this is the default
    [(0, $01STT.View).DRAFTS]: (0, $1UCmC.CONFLUENCE_DRAFTS_LOAD_KEY),
    [(0, $01STT.View).RECENT]: (0, $1UCmC.CONFLUENCE_RECENT_LOAD_KEY),
    [(0, $01STT.View).STARRED]: (0, $1UCmC.CONFLUENCE_STARRED_LOAD_KEY),
    [(0, $01STT.View).TASKS]: (0, $1UCmC.TASKS_HOME_LOAD_KEY)
};
// Views that render their own visible <h1>, so the screen-reader-only home heading is hidden.
const $a79337c1b0b1c1d5$var$VIEWS_WITH_OWN_HEADING = new Set([
    (0, $01STT.View).RECENT,
    (0, $01STT.View).STARRED,
    (0, $01STT.View).DRAFTS,
    (0, $01STT.View).TASKS
]);
const $a79337c1b0b1c1d5$var$i18n = (0, $kSwu1.defineMessages)({
    homeH1Text: {
        id: "home.h1.text",
        defaultMessage: "Confluence Home"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const $a79337c1b0b1c1d5$var$HomeContainer = /*#__PURE__*/ (0, $hGNbF.default)("div", {
    target: "e8dkq6p3"
})({
    name: "ykmbn9",
    styles: "display:flex;justify-content:center;background-color:var(--ds-surface, #FFFFFF);width:100%;min-height:calc(100vh - var(--bannerHeight, 0px) - var(--topNavigationHeight, 0px))"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $a79337c1b0b1c1d5$var$HomeLayout = /*#__PURE__*/ (0, $hGNbF.default)("div", {
    target: "e8dkq6p2"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles
({ rightSidebarCompensation: rightSidebarCompensation })=>({
        display: 'flex',
        flexBasis: '100%',
        margin: "var(--ds-space-400, 32px)",
        maxWidth: '1440px',
        minWidth: '400px',
        '--homeIsSingleColumn': 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        justifyContent: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`@media (max-width: ${(0, $1e2600c970f9c7ad$export$9ab51c7cc93666ed) + rightSidebarCompensation}px)`]: {
            '--homeIsSingleColumn': 1
        }
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const $a79337c1b0b1c1d5$var$ContentContainer = /*#__PURE__*/ (0, $hGNbF.default)("div", {
    target: "e8dkq6p1"
})({
    name: "bg7cl",
    styles: "display:flex;flex-basis:100%;max-width:1152px;min-width:516px;flex-grow:1"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a79337c1b0b1c1d5$var$ScreenReaderOnlyHeading = /*#__PURE__*/ (0, $hGNbF.default)("h1", {
    target: "e8dkq6p0"
})({
    name: "1ffvjbe",
    styles: "border:var(--ds-space-0, 0px);clip:rect(1px, 1px, 1px, 1px);clip-path:inset(50%);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;word-wrap:normal !important"
});
const $a79337c1b0b1c1d5$var$processAnalyticsEvents = (event)=>{
    event.update((payload)=>{
        return {
            ...payload,
            data: {
                ...payload.data,
                attributes: {
                    ...payload.data.attributes
                }
            }
        };
    });
};
const $a79337c1b0b1c1d5$export$b94310965bed44e6 = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    const homeReadyForUser = (0, $e1febe16f9c86232$export$db81afc2ba5d3f3b)();
    const rightSidebarCompensation = (0, $86e12f8c87d0ed6d$export$99e818ef77d5eb01)();
    const selectedView = (0, $ktNBJ.useSelectedView)();
    const hideHomeHeadingForView = $a79337c1b0b1c1d5$var$VIEWS_WITH_OWN_HEADING.has(selectedView);
    const { overrideUFORouteName: overrideUFORouteName } = (0, $dPJCf.useRouteActions)();
    (0, $cozmU.useEffect)(()=>{
        //set ufo page name correctly for each home route
        const pageLoadKey = $a79337c1b0b1c1d5$var$pageLoadMetricLookup[selectedView];
        if (pageLoadKey) overrideUFORouteName(pageLoadKey);
    }, [
        overrideUFORouteName,
        selectedView
    ]);
    (0, $f5f4d7bca1e6438a$export$26530c4be93733fa)();
    (0, $cozmU.useEffect)(()=>{
        // A/A test for the Confluence FY26 H2 holdout. Contact #twc-holdout-working-group for questions.
        (0, $6mKj3.expVal)('confluence_aa_test', 'isEnabled', false);
        // A/A test for the Confluence FY27 H1 holdout. Contact #twc-holdout-working-group for questions.
        (0, $6mKj3.expVal)('confluence_aa_test_fy27h1', 'isEnabled', false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: $a79337c1b0b1c1d5$var$processAnalyticsEvents
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kJNMt.ScrollToPageStart), {
        isSmooth: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a79337c1b0b1c1d5$var$ScreenReaderOnlyHeading, {
        "aria-hidden": hideHomeHeadingForView || undefined,
        "data-vc": "screen-reader-home-h1-text"
    }, intl.formatMessage($a79337c1b0b1c1d5$var$i18n.homeH1Text)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO,
        renderOnError: (0, $edxGF.Error)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a79337c1b0b1c1d5$var$HomeContainer, {
        "data-testid": "home",
        "data-vc": "home-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a79337c1b0b1c1d5$var$HomeLayout, {
        rightSidebarCompensation: rightSidebarCompensation,
        "data-testid": "home-layout"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a79337c1b0b1c1d5$var$ContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO,
        renderOnError: (0, $edxGF.Error)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ed354f3152b56d9c$export$47c3b27230c0b07f), null)))))), homeReadyForUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lLRfG.PageLoadEnd), {
        metric: (0, $gkVDU.CONFLUENCE_HOME_PAGE_LOAD),
        customData: {
            initiallyWikiRoute: (0, $6VdZc.browserMetricsState).previousRoute === (0, $1NBp8.WIKI).name
        },
        // Set TTI = FMP ( = FCP) when SSR
        stopTime: window.__SSR_RENDERED__ ? (0, $9eE57.getMark)('CFP-63.ssr-ttr') : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ZugQS.UFOTransitionMarkFMP), null)));
};
module.exports["Home"] = $a79337c1b0b1c1d5$export$b94310965bed44e6;

});

parcelRegister("lLRfG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $3PNw6 = parcelRequire("3PNw6");


var $78QFu = parcelRequire("78QFu");


var $7sK8i = parcelRequire("7sK8i");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $6VdZc = parcelRequire("6VdZc");


var $4XtQK = parcelRequire("4XtQK");


var $2O7Qv = parcelRequire("2O7Qv");

const $4291167636037428$var$PageLoadEndComponent = /*#__PURE__*/ (0, $cozmU.memo)(({ metric: metric, customData: customData = {}, stopTime: stopTime })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hasFiredRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredRef.current) return;
        hasFiredRef.current = true;
        if (metric) (0, $2O7Qv.addCustomTimingForMetric)(metric.key);
        (0, $3PNw6.addUFOCustomData)({
            ...customData,
            ...typeof stopTime === 'number' ? {
                stopTime: stopTime
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        });
        (0, $7sK8i.resumeLowPriorityEvents)();
    // Not adding exhaustive dependencies because we want this to fire only once,
    // despite any changes to `customData`
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        metric
    ]);
    (0, $4XtQK.reportHydrationError)(createAnalyticsEvent, metric?.key);
    return null;
});
const $4291167636037428$export$570dec5b65c6715b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($4291167636037428$var$PageLoadEndComponent);
module.exports["PageLoadEnd"] = $4291167636037428$export$570dec5b65c6715b;

});

parcelRegister("aJv6Q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("4XtQK", function(module, exports) {

var $5ZqQS = parcelRequire("5ZqQS");


var $dtDUi = parcelRequire("dtDUi");


var $6mKj3 = parcelRequire("6mKj3");

function $433efe87b2d05424$export$e885a680acb7d12e(createAnalyticsEvent, metricKey) {
    if (!(window?.__SSR_RENDERED__ && Boolean(window.__HYDRATION_FAILED__))) return;
    const { error: errorWithRoute, route: route } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
    const attribution = window.__SSR_REACT_STREAMING__ ? 'streaming-hydration' : 'hydration';
    if ((0, $6mKj3.expVal)('confluence_frontend_hydration_failure_reporting', 'isEnabled', false)) createAnalyticsEvent((0, $dtDUi.getHydrationFailureOperationalEvent)({
        source: `PageLoadEnd - ${metricKey}`,
        route: route,
        errorWithRoute: errorWithRoute,
        isSSRReactStreaming: Boolean(window.__SSR_REACT_STREAMING__)
    })).fire();
    else (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute, {
        attribution: attribution
    });
}
module.exports["reportHydrationError"] = $433efe87b2d05424$export$e885a680acb7d12e;

});

parcelRegister("dtDUi", function(module, exports) {
/* eslint-disable prefer-template */ 
var $64KID = parcelRequire("64KID");


var $fMEnQ = parcelRequire("fMEnQ");

const $dab54f7f733e6dc2$var$DOC_LINK = 'https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4848884799/Debugging+Hydration+Mismatches';
const $dab54f7f733e6dc2$export$476b9d1d68660527 = [
    {
        matchers: [
            /Hydration failed because the initial UI does not match what was rendered on the server/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /The server could not finish this Suspense boundary, likely due to an error during server rendering/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This root received an early update, before anything was able hydrate. Switched the entire root to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Text content does not match server-rendered HTML./
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating this Suspense boundary. Switched to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    //Production errors
    {
        matchers: [
            /Minified React error #418/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server in production. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #419/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #421/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #422/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #423/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #424/
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #425/
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    }
];
const $dab54f7f733e6dc2$export$5796b97ecb5a412 = (errorString)=>{
    for (const { matchers: matchers, friendlyError: friendlyError, hydrationFailed: hydrationFailed } of $dab54f7f733e6dc2$export$476b9d1d68660527){
        if (matchers.some((matcher)=>matcher.test(errorString))) return {
            ...friendlyError,
            originalString: errorString,
            hydrationFailed: hydrationFailed
        };
    }
    return {
        friendlyMessage: 'An additional error occurred, attached below.',
        docLink: '',
        fallback: true,
        originalString: errorString,
        hydrationFailed: false
    };
};
const $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2 = (url)=>{
    const match = (0, $fMEnQ.Route).matchFirst(Object.values((0, $64KID.namedRoutes)), url);
    return {
        error: new Error(`Hydration failed on route ${match?.name}`),
        route: match?.name || 'unknown'
    };
};
function $dab54f7f733e6dc2$export$260985b5e8a6fce6({ source: source, route: route, errorWithRoute: errorWithRoute, isSSRReactStreaming: isSSRReactStreaming }) {
    const attribution = isSSRReactStreaming ? 'streaming-hydration' : 'hydration';
    const error = $dab54f7f733e6dc2$var$trimTextLength(errorWithRoute.message || String(errorWithRoute), 1000);
    return {
        type: 'sendOperationalEvent',
        data: {
            source: source,
            route: route,
            action: 'failed',
            actionSubject: 'hydration',
            attributes: {
                error: error,
                route: route,
                attribution: attribution,
                isSSRReactStreaming: isSSRReactStreaming
            }
        }
    };
}
function $dab54f7f733e6dc2$var$trimTextLength(text, maxLength) {
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
}
module.exports["matchHydrationError"] = $dab54f7f733e6dc2$export$5796b97ecb5a412;
module.exports["getHydrationErrorWithRoute"] = $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2;
module.exports["getHydrationFailureOperationalEvent"] = $dab54f7f733e6dc2$export$260985b5e8a6fce6;

});

parcelRegister("2O7Qv", function(module, exports) {

var $a33Aa = parcelRequire("a33Aa");

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */ function $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interactionId, marks, metricKey) {
    let startTime;
    let endTime;
    for (const mark of marks){
        if (mark.type !== 'custom') continue;
        if (mark.name === `segment-start:${metricKey}`) startTime = mark.time;
        else if (mark.name === `segment-end:${metricKey}`) endTime = mark.time;
    }
    if (typeof startTime === 'number' && typeof endTime === 'number') (0, $a33Aa.addCustomTiming)(interactionId, [], {
        [`wf/react/${metricKey}`]: {
            startTime: startTime,
            endTime: endTime
        }
    });
}
function $7bc5b7230c0461d4$export$46796e5c908ea08e(metricKey) {
    const interaction = (0, $a33Aa.getActiveInteraction)();
    if (interaction) $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
}
module.exports["addCustomTimingForMetric"] = $7bc5b7230c0461d4$export$46796e5c908ea08e;

});

parcelRegister("kJNMt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7zgzO = parcelRequire("7zgzO");


var $fURMF = parcelRequire("fURMF");

const $0e8eac2a5609c7f2$export$139fec31c31601bb = ({ isSmooth: isSmooth })=>{
    const { getHash: getHash, getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    // we're using refs here to avoid violating the rules
    // of hooks, but still prevent ourselves from
    // scrolling to page start multiple times in case if
    // `RoutesContext` changes unexpectedly -- if that happens,
    // we'll just take the latest context values into account
    // when executing scroll, and ignore everything we've seen
    // prior to that.
    const getHashRef = (0, $cozmU.useRef)(getHash);
    const getQueryParamsRef = (0, $cozmU.useRef)(getQueryParams);
    getHashRef.current = getHash;
    getQueryParamsRef.current = getQueryParams;
    (0, $cozmU.useEffect)(()=>{
        const hash = getHashRef.current();
        const queryParams = getQueryParamsRef.current();
        const queryParamsThatTriggerScroll = [
            'focusedCommentId'
        ];
        const doesPageHaveExplicitScrollTarget = hash.length > 0 || queryParamsThatTriggerScroll.some((paramName)=>Boolean(queryParams[paramName]));
        if (!doesPageHaveExplicitScrollTarget) (0, $fURMF.scrollToPageStart)(isSmooth);
    }, [
        getHashRef,
        getQueryParamsRef,
        isSmooth
    ]);
    return null;
};
module.exports["ScrollToPageStart"] = $0e8eac2a5609c7f2$export$139fec31c31601bb;

});

parcelRegister("fURMF", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");

const $e9d2c346c5e28ee8$var$logger = (0, $7W8i8.getLogger)('scroll-to-element');
/**
 * Returns the HTMLElement that should be used as the scroll root.
 * This is the div with id=AkMainContent when on desktop, falling back to window on mobile.
 */ function $e9d2c346c5e28ee8$var$getScrollRootElement() {
    // On mobile sizes, scroll the window instead of #AkMainContent.
    // The magic number maps to media.above.md @media (min-width: 64rem) = 1024px.
    if (typeof document !== 'undefined' && typeof window !== 'undefined') {
        const akMainContent = document.getElementById('AkMainContent');
        if (window.innerWidth > 1023 && akMainContent) return akMainContent;
        return window;
    }
    return null;
}
const $e9d2c346c5e28ee8$var$explicitScrollListeners = new Set();
function $e9d2c346c5e28ee8$export$73ac910751bb2a9b(listener) {
    $e9d2c346c5e28ee8$var$explicitScrollListeners.add(listener);
    return ()=>$e9d2c346c5e28ee8$var$explicitScrollListeners.delete(listener);
}


function $e9d2c346c5e28ee8$var$invokeExplicitScrollListeners() {
    $e9d2c346c5e28ee8$var$explicitScrollListeners.forEach((listener)=>{
        try {
            listener();
        } catch (error) {
            Promise.all([
                (parcelRequire("2tnYT")),
                (parcelRequire("gBChQ"))
            ]).then(([{ getMonitoringClient: getMonitoringClient }, { Attribution: Attribution }])=>{
                getMonitoringClient().submitError(error, {
                    attribution: Attribution.PAGE_EXTENSIONS
                });
            }).catch(()=>{
            // ignore errors, we can't do anything at this point
            });
        }
    });
}
function $e9d2c346c5e28ee8$var$isSmoothScrollSupported() {
    return typeof document !== 'undefined' && 'scrollBehavior' in document.documentElement.style;
}
function $e9d2c346c5e28ee8$export$9b071b9c6dd786a2(isSmooth = false) {
    $e9d2c346c5e28ee8$var$invokeExplicitScrollListeners();
    const scrollRootElement = $e9d2c346c5e28ee8$var$getScrollRootElement();
    if (scrollRootElement) {
        // scrollRootElement is null during SSR — skip scrolling in that case
        if (isSmooth && $e9d2c346c5e28ee8$var$isSmoothScrollSupported()) scrollRootElement.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        else scrollRootElement.scrollTo(0, 0);
    }
}
function $e9d2c346c5e28ee8$export$2353115f31f4d15(element, scrollCorrectionPixels, scrollBehavior = 'auto', isLivePage) {
    const scrollRootElement = isLivePage ? typeof document !== 'undefined' ? document.querySelector('.fabric-editor-popup-scroll-parent') : null : $e9d2c346c5e28ee8$var$getScrollRootElement();
    let parentsOffset = 0;
    let currentOffsetParent = element.offsetParent;
    while(currentOffsetParent instanceof HTMLElement && currentOffsetParent != scrollRootElement){
        parentsOffset += currentOffsetParent.offsetTop;
        currentOffsetParent = currentOffsetParent.offsetParent;
    }
    const pageHeaderHeightAdjustment = 56;
    let top = element.offsetTop + (scrollCorrectionPixels || 0) + parentsOffset - pageHeaderHeightAdjustment;
    // check if element is nested inside table, if so we need to account for
    // sticky table header overlapping the element
    const hasTableParent = element?.closest('.pm-table-container td');
    if (hasTableParent && scrollCorrectionPixels) top = top + scrollCorrectionPixels * 1.25;
    $e9d2c346c5e28ee8$var$invokeExplicitScrollListeners();
    let behavior = scrollBehavior;
    if (behavior === 'smooth' && !$e9d2c346c5e28ee8$var$isSmoothScrollSupported()) behavior = 'auto';
    try {
        scrollRootElement?.scroll({
            top: top,
            behavior: behavior
        });
    } catch  {
        $e9d2c346c5e28ee8$var$logger.error`scroll() is not supported on #AkMainContent`;
    }
}
function $e9d2c346c5e28ee8$export$8611df79cae6484f(element) {
    if (typeof document !== 'undefined') {
        const scrollContainer = document.getElementById('AkMainContent');
        const breadcrumbHeaderHeight = 56; // FixedSpaceHeaderContainer (top nav) of the classic full page
        if (scrollContainer && scrollContainer.contains(element)) {
            // Let the browser calculate the exact scroll position
            const savedScroll = scrollContainer.scrollTop;
            element.scrollIntoView({
                behavior: 'instant',
                block: 'start'
            });
            const targetScroll = scrollContainer.scrollTop;
            scrollContainer.scrollTop = savedScroll;
            scrollContainer.scrollTo({
                left: 0,
                top: targetScroll - breadcrumbHeaderHeight,
                behavior: 'smooth'
            });
        } else element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }
}
module.exports["scrollToPageStart"] = $e9d2c346c5e28ee8$export$9b071b9c6dd786a2;
module.exports["scrollToElement"] = $e9d2c346c5e28ee8$export$2353115f31f4d15;
module.exports["scrollToBlockForViewPage"] = $e9d2c346c5e28ee8$export$8611df79cae6484f;

});

parcelRegister("2tnYT", function(module, exports) {

let $1cd0e4621aa50ab2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1cd0e4621aa50ab2$var$load("9fiFD").then(()=>parcelRequire('6SqQk'));

});

parcelRegister("gBChQ", function(module, exports) {

let $c16dcd029b34a01f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c16dcd029b34a01f$var$load("fH5Zm").then(()=>parcelRequire('bZmZf'));

});

parcelRegister("9eE57", function(module, exports) {

var $ge2sX = parcelRequire("ge2sX");


var $04e9M = parcelRequire("04e9M");


var $5ZqQS = parcelRequire("5ZqQS");

const $e8c3b9e45ae9a31e$export$1a717feb4df1a945 = (names)=>{
    if (window.performance?.clearMarks) names.forEach((name)=>window.performance.clearMarks(name));
};
const $e8c3b9e45ae9a31e$export$1c64491a086778ac = (name)=>{
    if (window.performance?.getEntriesByType) {
        const entries = window.performance.getEntriesByType(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce = (name)=>{
    if (window.performance?.getEntriesByName) {
        const entries = window.performance.getEntriesByName(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d = (a, b)=>{
    const entryA = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(a);
    const entryB = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(b);
    if (entryA && entryB) return Math.abs(entryA.startTime - entryB.startTime);
    return undefined;
};
const $e8c3b9e45ae9a31e$export$f45af69d005a6ed = (name)=>{
    const mark = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(name);
    if (mark) return mark.startTime;
    return undefined;
};
const $e8c3b9e45ae9a31e$export$91b34dd9e71ad666 = ({ subject: subject, subjectId: subjectId = '' })=>{
    const startMark = `${subject}.${subjectId}.start`;
    const endMark = `${subject}.${subjectId}.end`;
    $e8c3b9e45ae9a31e$export$1a717feb4df1a945([
        startMark,
        endMark
    ]);
    window.performance?.mark?.(startMark);
};
// Filter out feature flags with falsy values to save user bandwidth
const $e8c3b9e45ae9a31e$var$filterFeatureFlags = (flags = {})=>Object.keys(flags).filter((key)=>flags[key]).reduce((acc, key)=>{
        acc[key] = flags[key];
        return acc;
    }, {});
const $e8c3b9e45ae9a31e$var$performanceEnd = async ({ details: details, subject: subject, subjectId: subjectId, includeFeatureFlags: includeFeatureFlags })=>{
    const endMark = `${subject}.${subjectId}.end`;
    window.performance?.mark?.(endMark);
    const duration = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d(`${subject}.${subjectId}.start`, endMark);
    if (duration === undefined) return;
    try {
        const analyticsClientPromise = (0, $04e9M.getAnalyticsWebClient)();
        const sessionDataPromise = includeFeatureFlags ? (0, $ge2sX.getSessionData)() : Promise.resolve({
            featureFlags: {}
        });
        const [client, { featureFlags: featureFlags }] = await Promise.all([
            analyticsClientPromise,
            sessionDataPromise
        ]);
        const filteredFeatureFlags = $e8c3b9e45ae9a31e$var$filterFeatureFlags(featureFlags);
        client.sendOperationalEvent({
            tags: [
                'performance'
            ],
            source: 'confluence-frontend',
            action: 'done',
            actionSubject: subject,
            actionSubjectId: subjectId,
            attributes: {
                featureFlags: filteredFeatureFlags,
                duration: duration,
                ...details
            }
        });
    } catch (ex) {
        // This is a catch-all no-op, to prevent analytics component from screwing
        // up the user experience in case of any unexpected errors.
        (0, $5ZqQS.getMonitoringClient)().submitError(ex, {
            attribution: 'unknown'
        });
    }
};
const $e8c3b9e45ae9a31e$export$9cbdebb35a11386 = ({ subject: subject, subjectId: subjectId = '', details: details = {}, includeFeatureFlags: includeFeatureFlags = false })=>{
    const endMarkExists = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(`${subject}.${subjectId}.end`);
    if (!endMarkExists) $e8c3b9e45ae9a31e$var$performanceEnd({
        details: details,
        includeFeatureFlags: includeFeatureFlags,
        subject: subject,
        subjectId: subjectId
    });
};
module.exports["clearMarks"] = $e8c3b9e45ae9a31e$export$1a717feb4df1a945;
module.exports["getEntryByName"] = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce;
module.exports["measureMarks"] = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d;
module.exports["getMark"] = $e8c3b9e45ae9a31e$export$f45af69d005a6ed;
module.exports["perfMarkStart"] = $e8c3b9e45ae9a31e$export$91b34dd9e71ad666;
module.exports["perfMarkEnd"] = $e8c3b9e45ae9a31e$export$9cbdebb35a11386;

});

parcelRegister("1UCmC", function(module, exports) {
const $00aca2e58bbddd9e$export$9ee3c9e81070f140 = 'admin-announcement-banner-setting-page';
const $00aca2e58bbddd9e$export$162462d8f302c50a = 'advanced-search';
const $00aca2e58bbddd9e$export$17e011598d6a739d = 'unified-search';
const $00aca2e58bbddd9e$export$a88513891a2ab6b7 = 'confluence-home';
const $00aca2e58bbddd9e$export$5614199f62986e3b = 'all-drafts';
const $00aca2e58bbddd9e$export$3bbaa81ece500746 = 'recent-pages';
const $00aca2e58bbddd9e$export$b634edee624f5dc2 = 'starred-pages';
const $00aca2e58bbddd9e$export$5946c48030569b81 = 'content-history';
const $00aca2e58bbddd9e$export$1eefb862c6c6ce00 = 'edit-page';
const $00aca2e58bbddd9e$export$e164999ba8681ff6 = 'edit-template';
const $00aca2e58bbddd9e$export$6cdf3f4614ddd679 = 'edit-template-old';
const $00aca2e58bbddd9e$export$8faa34d8ba45e128 = 'embedded-view-page';
const $00aca2e58bbddd9e$export$3fb3338cf2b36704 = 'embedded-edit-page';
const $00aca2e58bbddd9e$export$779fbc1a16a8cb5d = 'global-permissions';
const $00aca2e58bbddd9e$export$9d8c586f3355f180 = 'inaccessible-page';
const $00aca2e58bbddd9e$export$a0c73183bde575ec = 'not-found';
const $00aca2e58bbddd9e$export$6d480c75094dbd7f = 'space-directory';
const $00aca2e58bbddd9e$export$8d0f9920174f22b4 = 'space-overview';
const $00aca2e58bbddd9e$export$228f2841a225e5ad = 'space-pages';
const $00aca2e58bbddd9e$export$fe4f0edc4d6532a8 = 'tasks-home';
const $00aca2e58bbddd9e$export$cc53520b570e0a46 = 'content-manager';
const $00aca2e58bbddd9e$export$bdc26b2b517231a = 'space-manager';
const $00aca2e58bbddd9e$export$b6d237d1e8f12e5d = 'template-gallery';
const $00aca2e58bbddd9e$export$a715ad00b824ec3f = 'view-page';
const $00aca2e58bbddd9e$export$132f38e0c19c02b6 = 'embedded-marketplace';
const $00aca2e58bbddd9e$export$d2dddf4422ad7ae8 = 'create-content';
const $00aca2e58bbddd9e$export$9c7a9f4f853f6fba = 'public-link-shared-page';
const $00aca2e58bbddd9e$export$643b9c181748da38 = 'public-link-site-setting-page';
const $00aca2e58bbddd9e$export$4716363caa82a23b = 'public-links-space-settings-page';
const $00aca2e58bbddd9e$export$75726af5c0ee9402 = 'whiteboard-view-page';
const $00aca2e58bbddd9e$export$afe76b61b3f9aaa8 = 'database-view-page';
const $00aca2e58bbddd9e$export$dd63a13fc6c1ba34 = 'embed-view-page';
const $00aca2e58bbddd9e$export$16aeb03ec0c24b89 = 'live-page';
const $00aca2e58bbddd9e$export$ce4e0f6f3d614d45 = 'live-edit';
const $00aca2e58bbddd9e$export$ecea02b4eaa314f3 = 'team-calendars';
const $00aca2e58bbddd9e$export$726cbfa087a55101 = 'admin-team-calendars';
const $00aca2e58bbddd9e$export$2f245ed7ebaea89 = 'admin-general-configuration';
const $00aca2e58bbddd9e$export$2af60fefae96902b = 'admin-configure-code-macro';
const $00aca2e58bbddd9e$export$fbea00ed02ef2502 = 'admin-default-space-logo-config';
const $00aca2e58bbddd9e$export$6e9c07174668ae36 = 'admin-header-and-footer';
const $00aca2e58bbddd9e$export$51fdddeccf175d74 = 'admin-security-configuration';
const $00aca2e58bbddd9e$export$2d0370cc7d14b72e = 'admin-templates-and-blueprints';
const $00aca2e58bbddd9e$export$a8d02dbd84c83dd = 'admin-import-spaces';
const $00aca2e58bbddd9e$export$1d91ea2ef976728a = 'admin-trashed-spaces';
const $00aca2e58bbddd9e$export$a13bfc71dc6b7924 = 'admin-application-navigator';
const $00aca2e58bbddd9e$export$3ba6335cd90d2e59 = 'admin-themes';
const $00aca2e58bbddd9e$export$cb4b6b707a32ee92 = 'admin-jira-macro-repair';
const $00aca2e58bbddd9e$export$5cb6689cb672a5c0 = 'admin-pdf-export';
const $00aca2e58bbddd9e$export$fff7d33fb1514c44 = 'admin-macro-usage';
const $00aca2e58bbddd9e$export$d4aa60a3ffc18652 = 'admin-user-access';
const $00aca2e58bbddd9e$export$52c0c13179848b50 = 'CONTENT_ANALYTICS';
const $00aca2e58bbddd9e$export$40dab65f060e1231 = 'SPACE_ANALYTICS';
const $00aca2e58bbddd9e$export$b682ed6d6fa429fb = 'INSTANCE_ANALYTICS';
const $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1 = 'space-details';
const $00aca2e58bbddd9e$export$2633c6986b98b723 = 'pdf-export-route';
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9ee3c9e81070f140;
module.exports["ADVANCED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$162462d8f302c50a;
module.exports["UNIFIED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$17e011598d6a739d;
module.exports["CONFLUENCE_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$a88513891a2ab6b7;
module.exports["CONFLUENCE_DRAFTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$5614199f62986e3b;
module.exports["CONFLUENCE_RECENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$3bbaa81ece500746;
module.exports["CONFLUENCE_STARRED_LOAD_KEY"] = $00aca2e58bbddd9e$export$b634edee624f5dc2;
module.exports["CONTENT_HISTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$5946c48030569b81;
module.exports["EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$1eefb862c6c6ce00;
module.exports["EDIT_TEMPLATE_LOAD_KEY"] = $00aca2e58bbddd9e$export$e164999ba8681ff6;
module.exports["EDIT_TEMPLATE_OLD_LOAD_KEY"] = $00aca2e58bbddd9e$export$6cdf3f4614ddd679;
module.exports["EMBEDDED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$8faa34d8ba45e128;
module.exports["EMBEDDED_EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$3fb3338cf2b36704;
module.exports["GLOBAL_PERMISSIONS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$779fbc1a16a8cb5d;
module.exports["INACCESSIBLE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9d8c586f3355f180;
module.exports["NOT_FOUND_LOAD_KEY"] = $00aca2e58bbddd9e$export$a0c73183bde575ec;
module.exports["SPACE_DIRECTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$6d480c75094dbd7f;
module.exports["SPACE_OVERVIEW_LOAD_KEY"] = $00aca2e58bbddd9e$export$8d0f9920174f22b4;
module.exports["SPACE_PAGES_LOAD_KEY"] = $00aca2e58bbddd9e$export$228f2841a225e5ad;
module.exports["TASKS_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$fe4f0edc4d6532a8;
module.exports["CONTENT_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$cc53520b570e0a46;
module.exports["SPACE_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$bdc26b2b517231a;
module.exports["TEMPLATE_GALLERY_LOAD_KEY"] = $00aca2e58bbddd9e$export$b6d237d1e8f12e5d;
module.exports["VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$a715ad00b824ec3f;
module.exports["EMBEDDED_MARKETPLACE_LOAD_KEY"] = $00aca2e58bbddd9e$export$132f38e0c19c02b6;
module.exports["CREATE_CONTENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$d2dddf4422ad7ae8;
module.exports["PUBLIC_LINK_SHARED_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9c7a9f4f853f6fba;
module.exports["PUBLIC_LINK_SITE_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$643b9c181748da38;
module.exports["WHITEBOARD_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$75726af5c0ee9402;
module.exports["DATABASE_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$afe76b61b3f9aaa8;
module.exports["EMBED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$dd63a13fc6c1ba34;
module.exports["LIVE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$16aeb03ec0c24b89;
module.exports["LIVE_PAGE_REACT_UFO_LOAD_KEY"] = $00aca2e58bbddd9e$export$ce4e0f6f3d614d45;
module.exports["TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$ecea02b4eaa314f3;
module.exports["ADMIN_TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$726cbfa087a55101;
module.exports["ADMIN_GENERAL_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$2f245ed7ebaea89;
module.exports["ADMIN_CONFIGURE_CODE_MACRO_LOAD_KEY"] = $00aca2e58bbddd9e$export$2af60fefae96902b;
module.exports["ADMIN_DEFAULT_SPACE_LOGO_CONFIG_LOAD_KEY"] = $00aca2e58bbddd9e$export$fbea00ed02ef2502;
module.exports["ADMIN_HEADER_AND_FOOTER_LOAD_KEY"] = $00aca2e58bbddd9e$export$6e9c07174668ae36;
module.exports["ADMIN_SECURITY_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$51fdddeccf175d74;
module.exports["ADMIN_TEMPLATES_AND_BLUEPRINTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$2d0370cc7d14b72e;
module.exports["ADMIN_IMPORT_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$a8d02dbd84c83dd;
module.exports["ADMIN_TRASHED_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$1d91ea2ef976728a;
module.exports["ADMIN_APPLICATION_NAVIGATOR_KEY"] = $00aca2e58bbddd9e$export$a13bfc71dc6b7924;
module.exports["ADMIN_THEMES_LOAD_KEY"] = $00aca2e58bbddd9e$export$3ba6335cd90d2e59;
module.exports["ADMIN_JIRA_MACRO_REPAIR_LOAD_KEY"] = $00aca2e58bbddd9e$export$cb4b6b707a32ee92;
module.exports["ADMIN_PDF_EXPORT_LOAD_KEY"] = $00aca2e58bbddd9e$export$5cb6689cb672a5c0;
module.exports["ADMIN_MACRO_USAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$fff7d33fb1514c44;
module.exports["ADMIN_USER_ACCESS_KEY"] = $00aca2e58bbddd9e$export$d4aa60a3ffc18652;
module.exports["PAGE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$52c0c13179848b50;
module.exports["SPACE_ANALYTICS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$40dab65f060e1231;
module.exports["SITE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$b682ed6d6fa429fb;
module.exports["SPACE_DETAILS_LOAD_KEY"] = $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1;
module.exports["PDF_EXPORT_ROUTE_LOAD_KEY"] = $00aca2e58bbddd9e$export$2633c6986b98b723;

});

parcelRegister("gkVDU", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");

var $fQ3iN = parcelRequire("fQ3iN");

var $i3c1S = parcelRequire("i3c1S");


var $1UCmC = parcelRequire("1UCmC");

var $jX1qB = parcelRequire("jX1qB");


var $bxcP5 = parcelRequire("bxcP5");

const $b122e413b2e9a2d7$export$6e008bd122a517f = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.HOME_OVERVIEW_RECENT_SEGMENT_KEY),
    // Set FMP = FCP if SSR (normally FMP = TTI)
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $b122e413b2e9a2d7$export$b80080833943f333 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY),
    // Set FMP = FCP if SSR (normally FMP = TTI)
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $b122e413b2e9a2d7$export$818919f7ea82fa05 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY),
    // Set FMP = FCP if SSR (normally FMP = TTI)
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $b122e413b2e9a2d7$var$expectedPageSegments = [
    $b122e413b2e9a2d7$export$6e008bd122a517f,
    (0, $bxcP5.HOME_OVERVIEW_FEED_PAGE_SEGMENT),
    $b122e413b2e9a2d7$export$818919f7ea82fa05,
    $b122e413b2e9a2d7$export$b80080833943f333
];
const $b122e413b2e9a2d7$export$238b3665fb2c4c64 = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.CONFLUENCE_HOME_LOAD_KEY),
    timings: (0, $i3c1S.getWaterfallTimings)($b122e413b2e9a2d7$var$expectedPageSegments),
    include: $b122e413b2e9a2d7$var$expectedPageSegments,
    // Set FMP = FCP if SSR (normally FMP = TTI)
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["HOME_OVERVIEW_RECENT_PAGE_SEGMENT"] = $b122e413b2e9a2d7$export$6e008bd122a517f;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_PAGE_SEGMENT"] = $b122e413b2e9a2d7$export$818919f7ea82fa05;
module.exports["CONFLUENCE_HOME_PAGE_LOAD"] = $b122e413b2e9a2d7$export$238b3665fb2c4c64;

});

parcelRegister("lSOAM", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");


var $8RwKN = parcelRequire("8RwKN");


var $64KID = parcelRequire("64KID");


var $fQ3iN = parcelRequire("fQ3iN");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    (0, $64KID.namedRoutes).HOME.name,
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $8RwKN.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const $2a47a9fc48674e91$export$c5aa7fcaede4a84d = (0, $iDdTC.metrics).pageLoad;
const $2a47a9fc48674e91$export$19ba7be4fcf34f3d = (0, $iDdTC.metrics).custom;
const $2a47a9fc48674e91$export$36d7a61d0660e29c = (0, $iDdTC.metrics).interaction;
const $2a47a9fc48674e91$var$concurrent = (0, $iDdTC.metrics).concurrent;
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["createPageLoadMetric"] = $2a47a9fc48674e91$export$c5aa7fcaede4a84d;
module.exports["createCustomMetric"] = $2a47a9fc48674e91$export$19ba7be4fcf34f3d;
module.exports["createInteractionMetric"] = $2a47a9fc48674e91$export$36d7a61d0660e29c;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("iDdTC", function(module, exports) {

var $9aI7t = parcelRequire("9aI7t");


var $b94r6 = parcelRequire("b94r6");

const $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54 = {
    pageLoad: $b94r6.pageLoad,
    pageSegmentLoad: $b94r6.pageSegmentLoad,
    interaction: $b94r6.interaction,
    custom: $b94r6.custom,
    concurrent: $9aI7t.concurrent
};
module.exports["metrics"] = $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54;

});

parcelRegister("9aI7t", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $b94r6 = parcelRequire("b94r6");

const $95763ae236d73d99$var$concurrentMetrics = {};
const $95763ae236d73d99$var$getKey = (config, type)=>`${type}--${config.key}`;
const $95763ae236d73d99$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $95763ae236d73d99$var$ensurePath = (config, type)=>{
    const key = $95763ae236d73d99$var$getKey(config, type);
    if (!(key in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[key] = {};
};
const $95763ae236d73d99$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $95763ae236d73d99$var$getKey(config, type);
    if (concurrentKey in $95763ae236d73d99$var$concurrentMetrics && $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $95763ae236d73d99$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $95763ae236d73d99$var$validateConfig(config);
    $95763ae236d73d99$var$ensurePath(config, type);
    const metricFromCache = $95763ae236d73d99$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $lCTbz.BMEventsType).INLINE_RESULT ? (0, $b94r6.interaction) : (0, $b94r6.custom);
    const metric = metricFactory(config);
    $95763ae236d73d99$var$concurrentMetrics[$95763ae236d73d99$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $95763ae236d73d99$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).CUSTOM)
};
module.exports["concurrent"] = $95763ae236d73d99$export$370df09ecc3de059;

});

parcelRegister("b94r6", function(module, exports) {

var $ipFlS = parcelRequire("ipFlS");


var $3L5Pu = parcelRequire("3L5Pu");


var $h51B5 = parcelRequire("h51B5");


var $lCTbz = parcelRequire("lCTbz");

const $01df368966019ba1$export$791d520f7e8058a5 = (config)=>{
    return new (0, $3L5Pu.PageLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_LOAD
    });
};
const $01df368966019ba1$export$94114666844d5f66 = (config)=>{
    return new (0, $h51B5.PageSegmentLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $01df368966019ba1$export$92473e6020ad89b4 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).INLINE_RESULT
    });
};
const $01df368966019ba1$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).CUSTOM
    });
};
module.exports["pageLoad"] = $01df368966019ba1$export$791d520f7e8058a5;
module.exports["pageSegmentLoad"] = $01df368966019ba1$export$94114666844d5f66;
module.exports["interaction"] = $01df368966019ba1$export$92473e6020ad89b4;
module.exports["custom"] = $01df368966019ba1$export$4c00f665f0d4b443;

});

parcelRegister("ipFlS", function(module, exports) {

var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $7IphZ = parcelRequire("7IphZ");

class $4db3d4178d03c3ea$export$efdd3e096bc27746 extends (0, $7IphZ.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $hvVQt.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $581yf.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}
module.exports["Metric"] = $4db3d4178d03c3ea$export$efdd3e096bc27746;

});

parcelRegister("3L5Pu", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $jk8rA = parcelRequire("jk8rA");


var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $lCTbz = parcelRequire("lCTbz");


var $2QFOI = parcelRequire("2QFOI");


var $wgCbG = parcelRequire("wgCbG");


var $eNslE = parcelRequire("eNslE");

class $bbca0ae0eaeecc15$export$3c51073271a9eac3 extends (0, $2QFOI.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $wgCbG.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $wgCbG.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $wgCbG.pageLoadMetaMetric).markFMP(mark);
            } else (0, $wgCbG.pageLoadMetaMetric).markFMP(this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $hvVQt.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $581yf.submitter).queue(data);
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $wgCbG.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $wgCbG.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $581yf.submitter).config.configChunk;
        if (!configChunk?.[(0, $lCTbz.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $eNslE.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $581yf.submitter).queue(webVitalMetric.getData());
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}
module.exports["PageLoadMetric"] = $bbca0ae0eaeecc15$export$3c51073271a9eac3;

});

parcelRegister("eNslE", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");

class $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7 extends (0, $7IphZ.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $lCTbz.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $7IphZ.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}
module.exports["WebVitalsMetric"] = $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7;

});

parcelRegister("h51B5", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");


var $ipFlS = parcelRequire("ipFlS");


var $wgCbG = parcelRequire("wgCbG");

class $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1 extends (0, $ipFlS.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $lCTbz.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $7IphZ.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $7IphZ.MetricState).STARTED) (0, $wgCbG.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP = 'fmp';
module.exports["PageSegmentLoadMetric"] = $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1;

});

parcelRegister("fQ3iN", function(module, exports) {
/**
 * BM3 Deprecation Phase 2 — gated wrapper around the raw BM3 page-segment-load factory.
 *
 * This file is the canonical implementation behind the public name
 * `createPageSegmentLoadMetric` (re-exported from
 * `@confluence/browser-metrics/entry-points/metricConfigs.ts`). All Confluence consumers
 * call the gated variant by virtue of importing the public name; there is no separate
 * "raw" public entry point.
 *
 * When the `cc_bm3_deprecation_phase_2` gate is OFF (default), every method call delegates
 * verbatim to the underlying BM3 PageSegmentLoadMetric so existing behaviour and the BM3
 * `PAGE_SEGMENT_LOAD` analytics events are preserved.
 *
 * When the gate is ON, the BM3 calls are skipped and equivalent UFO custom marks / custom
 * data are emitted instead. This lets us roll out the removal of the BM3 page-segment-load
 * events incrementally — controlled by Statsig — without touching any of the ~25
 * perf.config files or ~20 imperative call sites. Consumers continue to use
 * `METRIC.start()`, `.stop()`, `.cancel()`, `.mark()`, `.markFMP()`,
 * `.startFromPageLoad()` exactly as before; the gate decision is centralised here.
 *
 * The gate `fg(...)` is evaluated **inline at the callsite of each method**, never aliased
 * or wrapped, in line with the feature-gate-and-experiment-usage AGENTS guidance. Per-method
 * (rather than per-construction) evaluation is required because perf.config modules are
 * imported very early in app boot — earlier than Statsig data is loaded — so a one-shot
 * `fg()` call at construction time would always read the default (false) value.
 *
 * Implementation note: rather than returning a *new* wrapper object, this helper mutates
 * the real BM3 metric instance by overriding selected methods with bound functions that
 * consult the gate. This preserves the metric's class identity, prototype chain, and
 * private internal state so it remains a fully drop-in substitute everywhere a BM3
 * PageSegmentLoadMetric is used (including in `pageLoadMetric.include[]` / `until[]`
 * arrays where BM3 walks the internal experience graph).
 *
 * Once the gate has fully ramped, this file's body will be replaced with a UFO-only
 * implementation and the BM3 dependency removed entirely.
 */ 
var $3PNw6 = parcelRequire("3PNw6");


var $l6Cdg = parcelRequire("l6Cdg");


var $9wGTI = parcelRequire("9wGTI");


var $3YpC9 = parcelRequire("3YpC9");


var $kw6I9 = parcelRequire("kw6I9");

function $a96d58ddd476e3f0$export$34f706592a2f7442(config) {
    const metric = (0, $kw6I9.createBM3PageSegmentLoadMetricRaw)(config);
    const key = config.key;
    // Capture the original methods before overriding them.
    const realStart = metric.start.bind(metric);
    const realStartFromPageLoad = metric.startFromPageLoad.bind(metric);
    const realStop = metric.stop.bind(metric);
    const realCancel = metric.cancel.bind(metric);
    const realMark = metric.mark.bind(metric);
    const realMarkFMP = metric.markFMP.bind(metric);
    metric.start = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStart(...args);
    };
    metric.startFromPageLoad = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStartFromPageLoad(...args);
    };
    metric.stop = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            const opts = args[0];
            if (opts?.customData) (0, $3PNw6.addUFOCustomData)(opts.customData);
            return true;
        }
        return realStop(...args);
    };
    metric.cancel = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            // Note - there's no equivalent for cancel in UFO, so we use the end mark instead.
            (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            return;
        }
        return realCancel(...args);
    };
    metric.mark = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [name, timestamp] = args;
            (0, $l6Cdg.addUFOCustomMark)(name, timestamp);
            return;
        }
        return realMark(...args);
    };
    metric.markFMP = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [timestamp] = args;
            (0, $l6Cdg.addUFOCustomMark)(`fmp:${key}`, timestamp);
            return;
        }
        return realMarkFMP(...args);
    };
    return metric;
}
module.exports["createPageSegmentLoadMetric"] = $a96d58ddd476e3f0$export$34f706592a2f7442;

});

parcelRegister("3YpC9", function(module, exports) {
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';
module.exports["PAGE_SEGMENT_MARK_PREFIX_START"] = $4dbe182ee19642b3$export$f59b3ea823fcdb3d;
module.exports["PAGE_SEGMENT_MARK_PREFIX_END"] = $4dbe182ee19642b3$export$a217b163593f51a;

});

parcelRegister("kw6I9", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");

const $864083edfead32eb$export$2a2fe1e11b4e0413 = (0, $iDdTC.metrics).pageSegmentLoad;
module.exports["createBM3PageSegmentLoadMetricRaw"] = $864083edfead32eb$export$2a2fe1e11b4e0413;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("bxcP5", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $57ed722ec78a151a$export$bdce15adff7bb212 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.HOME_OVERVIEW_FEED_SEGMENT_KEY),
    // Set FMP = FCP if SSR (normally FMP = TTI)
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["HOME_OVERVIEW_FEED_PAGE_SEGMENT"] = $57ed722ec78a151a$export$bdce15adff7bb212;

});

parcelRegister("ktNBJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7zgzO = parcelRequire("7zgzO");


var $01STT = parcelRequire("01STT");

const $c653c8ded1552412$export$639584d6e9163827 = ()=>{
    const { match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const view = match?.params?.view;
    return Object.values((0, $01STT.View)).includes(view) ? view : (0, $01STT.View).OVERVIEW;
};
module.exports["useSelectedView"] = $c653c8ded1552412$export$639584d6e9163827;

});

parcelRegister("c8cx7", function(module, exports) {
$parcel$export(module.exports, "Error", () => (parcelRequire("edxGF")).Error);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");


var $edxGF = parcelRequire("edxGF");


const $1ba03bfb9a780e1a$export$d6cf4bb669b36f29 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "mMjZO",
    name: "ForYou",
    loader: async ()=>(await (parcelRequire("TdNcZ"))).ForYou
});

const $1ba03bfb9a780e1a$export$1147d6e1036afec = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "yueUn",
    name: "Recent",
    loader: async ()=>(await (parcelRequire("daGJt"))).Recent
});

const $1ba03bfb9a780e1a$export$8cd2a0520fb55072 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "yeflu",
    name: "Starred",
    loader: async ()=>(await (parcelRequire("iO3of"))).Starred
});

const $1ba03bfb9a780e1a$export$1d3fe8f04fd169f5 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "g-Rym",
    name: "Drafts",
    loader: async ()=>(await (parcelRequire("h0aDn"))).Drafts
});

const $1ba03bfb9a780e1a$export$77bc526bfccc9372 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "J_FnP",
    name: "Tasks",
    loader: async ()=>(await (parcelRequire("iT3gB"))).Tasks
});
module.exports["ForYou"] = $1ba03bfb9a780e1a$export$d6cf4bb669b36f29;
module.exports["Recent"] = $1ba03bfb9a780e1a$export$1147d6e1036afec;
module.exports["Starred"] = $1ba03bfb9a780e1a$export$8cd2a0520fb55072;
module.exports["Drafts"] = $1ba03bfb9a780e1a$export$1d3fe8f04fd169f5;
module.exports["Tasks"] = $1ba03bfb9a780e1a$export$77bc526bfccc9372;

});

parcelRegister("TdNcZ", function(module, exports) {

let $0a5fd61bd335b38f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0a5fd61bd335b38f$var$load("kT6dz"),
    $0a5fd61bd335b38f$var$load("dKv6J"),
    $0a5fd61bd335b38f$var$load("8JUxP"),
    $0a5fd61bd335b38f$var$load("XbUoB"),
    $0a5fd61bd335b38f$var$load("iUz8S"),
    $0a5fd61bd335b38f$var$load("ddvkk"),
    $0a5fd61bd335b38f$var$load("3upHR"),
    $0a5fd61bd335b38f$var$load("bjimZ"),
    $0a5fd61bd335b38f$var$load("kUfAt"),
    $0a5fd61bd335b38f$var$load("kahxF"),
    $0a5fd61bd335b38f$var$load("fkbDX"),
    $0a5fd61bd335b38f$var$load("36Av5"),
    $0a5fd61bd335b38f$var$load("4WTdS"),
    $0a5fd61bd335b38f$var$load("HaNwW"),
    $0a5fd61bd335b38f$var$load("RylUf"),
    $0a5fd61bd335b38f$var$load("cIET7"),
    $0a5fd61bd335b38f$var$load("1GCFv"),
    $0a5fd61bd335b38f$var$load("7oAXW"),
    $0a5fd61bd335b38f$var$load("idSqX"),
    $0a5fd61bd335b38f$var$load("7SX5u"),
    $0a5fd61bd335b38f$var$load("gbejv"),
    $0a5fd61bd335b38f$var$load("GD9EA"),
    $0a5fd61bd335b38f$var$load("h1yOv"),
    $0a5fd61bd335b38f$var$load("7gL7H"),
    $0a5fd61bd335b38f$var$load("cmmpX"),
    $0a5fd61bd335b38f$var$load("j6n20"),
    $0a5fd61bd335b38f$var$load("gpnR1"),
    $0a5fd61bd335b38f$var$load("6wr18"),
    $0a5fd61bd335b38f$var$load("59hV4"),
    $0a5fd61bd335b38f$var$load("8zMmc"),
    $0a5fd61bd335b38f$var$load("4x9Jx"),
    $0a5fd61bd335b38f$var$load("ezm4t"),
    $0a5fd61bd335b38f$var$load("h9ofP"),
    $0a5fd61bd335b38f$var$load("4JSav"),
    $0a5fd61bd335b38f$var$load("dGhn8"),
    $0a5fd61bd335b38f$var$load("5omeF"),
    $0a5fd61bd335b38f$var$load("cHcD4"),
    $0a5fd61bd335b38f$var$load("2m65P"),
    $0a5fd61bd335b38f$var$load("3kVph"),
    $0a5fd61bd335b38f$var$load("ffEVr"),
    $0a5fd61bd335b38f$var$load("hVR94"),
    $0a5fd61bd335b38f$var$load("4Zbes"),
    $0a5fd61bd335b38f$var$load("ghNAx"),
    $0a5fd61bd335b38f$var$load("he34V"),
    $0a5fd61bd335b38f$var$load("dEUQZ"),
    $0a5fd61bd335b38f$var$load("jZMUd"),
    $0a5fd61bd335b38f$var$load("2EIkU"),
    $0a5fd61bd335b38f$var$load("80Yra"),
    $0a5fd61bd335b38f$var$load("epiOa"),
    $0a5fd61bd335b38f$var$load("7TnhR"),
    $0a5fd61bd335b38f$var$load("houtd"),
    $0a5fd61bd335b38f$var$load("3Pqne"),
    $0a5fd61bd335b38f$var$load("biEu6"),
    $0a5fd61bd335b38f$var$load("hhss7"),
    $0a5fd61bd335b38f$var$load("Wowvf"),
    $0a5fd61bd335b38f$var$load("eRhBr"),
    $0a5fd61bd335b38f$var$load("hZ2FX"),
    $0a5fd61bd335b38f$var$load("bwml0"),
    $0a5fd61bd335b38f$var$load("i8XV5"),
    $0a5fd61bd335b38f$var$load("9ZY0g"),
    $0a5fd61bd335b38f$var$load("7EorR"),
    $0a5fd61bd335b38f$var$load("4lIqn")
]).then(()=>parcelRequire('kId2E'));

});

parcelRegister("daGJt", function(module, exports) {

let $996d5b4e0fa05f28$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $996d5b4e0fa05f28$var$load("ibo4x"),
    $996d5b4e0fa05f28$var$load("iWnyc"),
    $996d5b4e0fa05f28$var$load("dKv6J"),
    $996d5b4e0fa05f28$var$load("8JUxP"),
    $996d5b4e0fa05f28$var$load("bb3WM"),
    $996d5b4e0fa05f28$var$load("iwH7W"),
    $996d5b4e0fa05f28$var$load("lCkJt"),
    $996d5b4e0fa05f28$var$load("32NHR"),
    $996d5b4e0fa05f28$var$load("glmO2"),
    $996d5b4e0fa05f28$var$load("jlgCH"),
    $996d5b4e0fa05f28$var$load("gW7tk"),
    $996d5b4e0fa05f28$var$load("6damH"),
    $996d5b4e0fa05f28$var$load("1GCFv"),
    $996d5b4e0fa05f28$var$load("h4Nf7"),
    $996d5b4e0fa05f28$var$load("4XkGy"),
    $996d5b4e0fa05f28$var$load("fuOfV"),
    $996d5b4e0fa05f28$var$load("jL1Ke"),
    $996d5b4e0fa05f28$var$load("5MQ0D"),
    $996d5b4e0fa05f28$var$load("j6n20"),
    $996d5b4e0fa05f28$var$load("gpnR1"),
    $996d5b4e0fa05f28$var$load("6wr18"),
    $996d5b4e0fa05f28$var$load("59hV4"),
    $996d5b4e0fa05f28$var$load("8zMmc"),
    $996d5b4e0fa05f28$var$load("4x9Jx"),
    $996d5b4e0fa05f28$var$load("ffEVr"),
    $996d5b4e0fa05f28$var$load("aIddG"),
    $996d5b4e0fa05f28$var$load("jZMUd"),
    $996d5b4e0fa05f28$var$load("2EIkU"),
    $996d5b4e0fa05f28$var$load("kFiBp"),
    $996d5b4e0fa05f28$var$load("3Pqne"),
    $996d5b4e0fa05f28$var$load("biEu6"),
    $996d5b4e0fa05f28$var$load("hhss7"),
    $996d5b4e0fa05f28$var$load("Wowvf"),
    $996d5b4e0fa05f28$var$load("eRhBr"),
    $996d5b4e0fa05f28$var$load("bwml0"),
    $996d5b4e0fa05f28$var$load("i8XV5"),
    $996d5b4e0fa05f28$var$load("7EorR"),
    $996d5b4e0fa05f28$var$load("f5aXs")
]).then(()=>parcelRequire('5YLd2'));

});

parcelRegister("iO3of", function(module, exports) {

let $db0f86b98b0fd40b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $db0f86b98b0fd40b$var$load("ibo4x"),
    $db0f86b98b0fd40b$var$load("iWnyc"),
    $db0f86b98b0fd40b$var$load("dKv6J"),
    $db0f86b98b0fd40b$var$load("8JUxP"),
    $db0f86b98b0fd40b$var$load("bb3WM"),
    $db0f86b98b0fd40b$var$load("iwH7W"),
    $db0f86b98b0fd40b$var$load("lCkJt"),
    $db0f86b98b0fd40b$var$load("32NHR"),
    $db0f86b98b0fd40b$var$load("glmO2"),
    $db0f86b98b0fd40b$var$load("jlgCH"),
    $db0f86b98b0fd40b$var$load("gW7tk"),
    $db0f86b98b0fd40b$var$load("6damH"),
    $db0f86b98b0fd40b$var$load("1GCFv"),
    $db0f86b98b0fd40b$var$load("h4Nf7"),
    $db0f86b98b0fd40b$var$load("4XkGy"),
    $db0f86b98b0fd40b$var$load("fuOfV"),
    $db0f86b98b0fd40b$var$load("jL1Ke"),
    $db0f86b98b0fd40b$var$load("5MQ0D"),
    $db0f86b98b0fd40b$var$load("j6n20"),
    $db0f86b98b0fd40b$var$load("gpnR1"),
    $db0f86b98b0fd40b$var$load("6wr18"),
    $db0f86b98b0fd40b$var$load("59hV4"),
    $db0f86b98b0fd40b$var$load("8zMmc"),
    $db0f86b98b0fd40b$var$load("4x9Jx"),
    $db0f86b98b0fd40b$var$load("ffEVr"),
    $db0f86b98b0fd40b$var$load("aIddG"),
    $db0f86b98b0fd40b$var$load("jZMUd"),
    $db0f86b98b0fd40b$var$load("2EIkU"),
    $db0f86b98b0fd40b$var$load("kFiBp"),
    $db0f86b98b0fd40b$var$load("3Pqne"),
    $db0f86b98b0fd40b$var$load("biEu6"),
    $db0f86b98b0fd40b$var$load("hhss7"),
    $db0f86b98b0fd40b$var$load("Wowvf"),
    $db0f86b98b0fd40b$var$load("eRhBr"),
    $db0f86b98b0fd40b$var$load("bwml0"),
    $db0f86b98b0fd40b$var$load("i8XV5"),
    $db0f86b98b0fd40b$var$load("7EorR"),
    $db0f86b98b0fd40b$var$load("1U3XO")
]).then(()=>parcelRequire('2uYRD'));

});

parcelRegister("h0aDn", function(module, exports) {

let $c60aaf7c7d2b5d5c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c60aaf7c7d2b5d5c$var$load("ibo4x"),
    $c60aaf7c7d2b5d5c$var$load("iWnyc"),
    $c60aaf7c7d2b5d5c$var$load("dKv6J"),
    $c60aaf7c7d2b5d5c$var$load("8JUxP"),
    $c60aaf7c7d2b5d5c$var$load("bb3WM"),
    $c60aaf7c7d2b5d5c$var$load("iwH7W"),
    $c60aaf7c7d2b5d5c$var$load("lCkJt"),
    $c60aaf7c7d2b5d5c$var$load("32NHR"),
    $c60aaf7c7d2b5d5c$var$load("glmO2"),
    $c60aaf7c7d2b5d5c$var$load("jlgCH"),
    $c60aaf7c7d2b5d5c$var$load("gW7tk"),
    $c60aaf7c7d2b5d5c$var$load("6damH"),
    $c60aaf7c7d2b5d5c$var$load("1GCFv"),
    $c60aaf7c7d2b5d5c$var$load("h4Nf7"),
    $c60aaf7c7d2b5d5c$var$load("4XkGy"),
    $c60aaf7c7d2b5d5c$var$load("fuOfV"),
    $c60aaf7c7d2b5d5c$var$load("jL1Ke"),
    $c60aaf7c7d2b5d5c$var$load("5MQ0D"),
    $c60aaf7c7d2b5d5c$var$load("j6n20"),
    $c60aaf7c7d2b5d5c$var$load("gpnR1"),
    $c60aaf7c7d2b5d5c$var$load("6wr18"),
    $c60aaf7c7d2b5d5c$var$load("59hV4"),
    $c60aaf7c7d2b5d5c$var$load("8zMmc"),
    $c60aaf7c7d2b5d5c$var$load("4x9Jx"),
    $c60aaf7c7d2b5d5c$var$load("ffEVr"),
    $c60aaf7c7d2b5d5c$var$load("aIddG"),
    $c60aaf7c7d2b5d5c$var$load("jZMUd"),
    $c60aaf7c7d2b5d5c$var$load("2EIkU"),
    $c60aaf7c7d2b5d5c$var$load("kFiBp"),
    $c60aaf7c7d2b5d5c$var$load("3Pqne"),
    $c60aaf7c7d2b5d5c$var$load("biEu6"),
    $c60aaf7c7d2b5d5c$var$load("hhss7"),
    $c60aaf7c7d2b5d5c$var$load("Wowvf"),
    $c60aaf7c7d2b5d5c$var$load("eRhBr"),
    $c60aaf7c7d2b5d5c$var$load("bwml0"),
    $c60aaf7c7d2b5d5c$var$load("i8XV5"),
    $c60aaf7c7d2b5d5c$var$load("7EorR"),
    $c60aaf7c7d2b5d5c$var$load("CK44F")
]).then(()=>parcelRequire('iToIr'));

});

parcelRegister("iT3gB", function(module, exports) {

let $dbffe5c5ec3cf908$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $dbffe5c5ec3cf908$var$load("kT6dz"),
    $dbffe5c5ec3cf908$var$load("fgbNm"),
    $dbffe5c5ec3cf908$var$load("dKv6J"),
    $dbffe5c5ec3cf908$var$load("8JUxP"),
    $dbffe5c5ec3cf908$var$load("bjimZ"),
    $dbffe5c5ec3cf908$var$load("kUfAt"),
    $dbffe5c5ec3cf908$var$load("HaNwW"),
    $dbffe5c5ec3cf908$var$load("RylUf"),
    $dbffe5c5ec3cf908$var$load("ilUG7"),
    $dbffe5c5ec3cf908$var$load("efUj2"),
    $dbffe5c5ec3cf908$var$load("cIET7"),
    $dbffe5c5ec3cf908$var$load("aJLFD"),
    $dbffe5c5ec3cf908$var$load("7oAXW"),
    $dbffe5c5ec3cf908$var$load("idSqX"),
    $dbffe5c5ec3cf908$var$load("gbejv"),
    $dbffe5c5ec3cf908$var$load("GD9EA"),
    $dbffe5c5ec3cf908$var$load("4XkGy"),
    $dbffe5c5ec3cf908$var$load("h1yOv"),
    $dbffe5c5ec3cf908$var$load("kHXvF"),
    $dbffe5c5ec3cf908$var$load("7gL7H"),
    $dbffe5c5ec3cf908$var$load("jL1Ke"),
    $dbffe5c5ec3cf908$var$load("cmmpX"),
    $dbffe5c5ec3cf908$var$load("j6n20"),
    $dbffe5c5ec3cf908$var$load("gpnR1"),
    $dbffe5c5ec3cf908$var$load("6wr18"),
    $dbffe5c5ec3cf908$var$load("59hV4"),
    $dbffe5c5ec3cf908$var$load("8zMmc"),
    $dbffe5c5ec3cf908$var$load("4x9Jx"),
    $dbffe5c5ec3cf908$var$load("ezm4t"),
    $dbffe5c5ec3cf908$var$load("h9ofP"),
    $dbffe5c5ec3cf908$var$load("4JSav"),
    $dbffe5c5ec3cf908$var$load("lbsQO"),
    $dbffe5c5ec3cf908$var$load("dGhn8"),
    $dbffe5c5ec3cf908$var$load("5omeF"),
    $dbffe5c5ec3cf908$var$load("cHcD4"),
    $dbffe5c5ec3cf908$var$load("2m65P"),
    $dbffe5c5ec3cf908$var$load("3kVph"),
    $dbffe5c5ec3cf908$var$load("ffEVr"),
    $dbffe5c5ec3cf908$var$load("ghNAx"),
    $dbffe5c5ec3cf908$var$load("he34V"),
    $dbffe5c5ec3cf908$var$load("dEUQZ"),
    $dbffe5c5ec3cf908$var$load("aIddG"),
    $dbffe5c5ec3cf908$var$load("jZMUd"),
    $dbffe5c5ec3cf908$var$load("2EIkU"),
    $dbffe5c5ec3cf908$var$load("80Yra"),
    $dbffe5c5ec3cf908$var$load("epiOa"),
    $dbffe5c5ec3cf908$var$load("7TnhR"),
    $dbffe5c5ec3cf908$var$load("houtd"),
    $dbffe5c5ec3cf908$var$load("3Pqne"),
    $dbffe5c5ec3cf908$var$load("biEu6"),
    $dbffe5c5ec3cf908$var$load("hhss7"),
    $dbffe5c5ec3cf908$var$load("Wowvf"),
    $dbffe5c5ec3cf908$var$load("eRhBr"),
    $dbffe5c5ec3cf908$var$load("daX4F"),
    $dbffe5c5ec3cf908$var$load("hZ2FX"),
    $dbffe5c5ec3cf908$var$load("bwml0"),
    $dbffe5c5ec3cf908$var$load("i8XV5"),
    $dbffe5c5ec3cf908$var$load("9ZY0g"),
    $dbffe5c5ec3cf908$var$load("7EorR"),
    $dbffe5c5ec3cf908$var$load("6d1e0")
]).then(()=>parcelRequire('7JJfe'));

});

parcelRegister("edxGF", function(module, exports) {
/* Error.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $aQbeC = parcelRequire("aQbeC");


var $iMnC5 = parcelRequire("iMnC5");


var $iGOxg = parcelRequire("iGOxg");

const $c2d65f0233a810f4$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    errorHeader: {
        id: "home.views.error.header",
        defaultMessage: "We\u2019re having trouble getting your results"
    },
    errorAction: {
        id: "home.views.error.action",
        defaultMessage: "Refresh and try again."
    }
});
const $c2d65f0233a810f4$var$errorContainerStyles = null;
const $c2d65f0233a810f4$var$errorHeaderStyles = null;
const $c2d65f0233a810f4$export$edf27be85e5f6da0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_19pk88uy _1e0c1txw _2lx21bp4 _4cvr1h6o _1bsb1osq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iGOxg))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("h3", {
        className: (0, $hekY6.default)([
            "_19pk1qjk"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c2d65f0233a810f4$export$a7357cdd1f0b0168.errorHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        paddingBlockStart: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c2d65f0233a810f4$export$a7357cdd1f0b0168.errorAction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        paddingBlockStart: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aQbeC.ErrorDetail), null)));
module.exports["i18n"] = $c2d65f0233a810f4$export$a7357cdd1f0b0168;
module.exports["Error"] = $c2d65f0233a810f4$export$edf27be85e5f6da0;

});

parcelRegister("aQbeC", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $i1t43 = parcelRequire("i1t43");


var $3izAL = parcelRequire("3izAL");


var $2wCqQ = parcelRequire("2wCqQ");


var $buxP3 = parcelRequire("buxP3");


var $c9IWh = parcelRequire("c9IWh");


var $fJlJm = parcelRequire("fJlJm");


var $cqmCC = parcelRequire("cqmCC");


var $d5QxR = parcelRequire("d5QxR");

const $ab3d7e6c3ad6ea9c$var$CONFLUENCE_STATUS_PAGE_URL = 'https://confluence.status.atlassian.com/';
const $ab3d7e6c3ad6ea9c$var$ERROR_COMPONENT_KB_ARTICLE_URL = 'https://confluence.atlassian.com/confkb/getting-we-ve-hit-a-snag-error-message-when-viewing-confluence-pages-1095238852.html';
const $ab3d7e6c3ad6ea9c$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    description: {
        id: "error-boundary.description",
        defaultMessage: "The issue should resolve on its own. In the meantime, you can check the <statuslink>status page</statuslink>. There may be a known incident reported related to <kblink>this error</kblink>. If it keeps happening, ask your admin to contact <supportlink>our support team</supportlink> and give them:"
    },
    status403Description: {
        id: "error-boundary.status.403.description",
        defaultMessage: "To resolve this, try reloading or reach out to your admin about getting access. You can also check the <statuslink>status page</statuslink> about a potential known incident related to this <kblink>error</kblink>. If it keeps happening, ask your admin to contact <supportlink>support</supportlink> and give them:"
    },
    errorHash: {
        id: "error-boundary.code",
        defaultMessage: "The code associated with this error: {code}"
    },
    errorHashInCodeBlock: {
        id: "error-boundary.code.in-code-block",
        defaultMessage: "Hash: {code}"
    },
    url: {
        id: "error-boundary.url",
        defaultMessage: "The URL of this page"
    },
    trace: {
        id: "error-boundary.trace",
        defaultMessage: "Trace: {traceId}"
    }
});
const $ab3d7e6c3ad6ea9c$var$codeBlockContainerStyles = (0, $buxP3.xcss)({
    maxWidth: '330px'
});
function $ab3d7e6c3ad6ea9c$export$1b15b3abeb74ae7c(t0) {
    const $ = (0, $bDgLe.c)(24);
    const { error: error, isFullSizeErrorComponent: isFullSizeErrorComponent } = t0;
    let t1;
    if ($[0] !== error) {
        t1 = !!error ? (0, $fJlJm.getGraphqlErrorAttributes)(error) : undefined;
        $[0] = error;
        $[1] = t1;
    } else t1 = $[1];
    const graphqlErrorAttributes = t1;
    let t2;
    if ($[2] !== error) {
        t2 = !!error ? (0, $fJlJm.getReactErrorAttributes)(error) : undefined;
        $[2] = error;
        $[3] = t2;
    } else t2 = $[3];
    const reactErrorAttributes = t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $c9IWh.getActiveTrace)();
        $[4] = t3;
    } else t3 = $[4];
    const experienceTraceContext = t3;
    const errorHashCode = reactErrorAttributes ? reactErrorAttributes.errorHashCode : undefined;
    const traceId = experienceTraceContext?.traceId ?? graphqlErrorAttributes?.traceId;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const intl = (0, $kSwu1.useIntl)();
    let lines;
    if ($[5] !== errorHashCode || $[6] !== intl || $[7] !== traceId) {
        lines = [];
        if (errorHashCode) {
            let t4;
            if ($[9] !== errorHashCode || $[10] !== intl) {
                t4 = intl.formatMessage($ab3d7e6c3ad6ea9c$export$a7357cdd1f0b0168.errorHashInCodeBlock, {
                    code: errorHashCode
                });
                $[9] = errorHashCode;
                $[10] = intl;
                $[11] = t4;
            } else t4 = $[11];
            lines.push(t4);
        }
        if (traceId) {
            let t4;
            if ($[12] !== intl || $[13] !== traceId) {
                t4 = intl.formatMessage($ab3d7e6c3ad6ea9c$export$a7357cdd1f0b0168.trace, {
                    traceId: traceId
                });
                $[12] = intl;
                $[13] = traceId;
                $[14] = t4;
            } else t4 = $[14];
            lines.push(t4);
        }
        $[5] = errorHashCode;
        $[6] = intl;
        $[7] = traceId;
        $[8] = lines;
    } else lines = $[8];
    const codeBlockLines = lines;
    let t4;
    let t5;
    if ($[15] !== createAnalyticsEvent || $[16] !== errorHashCode || $[17] !== traceId) {
        t4 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "errorDetail",
                    attributes: {
                        errorHashCode: errorHashCode,
                        traceId: traceId
                    }
                }
            })?.fire();
        };
        t5 = [
            createAnalyticsEvent,
            errorHashCode,
            traceId
        ];
        $[15] = createAnalyticsEvent;
        $[16] = errorHashCode;
        $[17] = traceId;
        $[18] = t4;
        $[19] = t5;
    } else {
        t4 = $[18];
        t5 = $[19];
    }
    (0, $cozmU.useEffect)(t4, t5);
    const i18nDescription = graphqlErrorAttributes?.statusCode === 403 ? $ab3d7e6c3ad6ea9c$export$a7357cdd1f0b0168.status403Description : $ab3d7e6c3ad6ea9c$export$a7357cdd1f0b0168.description;
    let t6;
    if ($[20] !== codeBlockLines || $[21] !== i18nDescription || $[22] !== isFullSizeErrorComponent) {
        t6 = codeBlockLines.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...i18nDescription,
            tagName: "p",
            values: {
                supportlink: $ab3d7e6c3ad6ea9c$var$_temp,
                statuslink: $ab3d7e6c3ad6ea9c$var$_temp2,
                kblink: $ab3d7e6c3ad6ea9c$var$_temp3
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: isFullSizeErrorComponent && $ab3d7e6c3ad6ea9c$var$codeBlockContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5QxR.CodeBlockWithCopyButton), {
            lines: codeBlockLines,
            analyticsSource: "errorDetail"
        }))) : null;
        $[20] = codeBlockLines;
        $[21] = i18nDescription;
        $[22] = isFullSizeErrorComponent;
        $[23] = t6;
    } else t6 = $[23];
    return t6;
}
function $ab3d7e6c3ad6ea9c$var$_temp3(chunks_1) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ab3d7e6c3ad6ea9c$export$8ab5c6f0105ebb52, {
        url: $ab3d7e6c3ad6ea9c$var$ERROR_COMPONENT_KB_ARTICLE_URL,
        chunks: chunks_1,
        analyticsName: "knowledgebaseLink"
    });
}
function $ab3d7e6c3ad6ea9c$var$_temp2(chunks_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ab3d7e6c3ad6ea9c$export$8ab5c6f0105ebb52, {
        url: $ab3d7e6c3ad6ea9c$var$CONFLUENCE_STATUS_PAGE_URL,
        chunks: chunks_0,
        analyticsName: "statusPageLink"
    });
}
function $ab3d7e6c3ad6ea9c$var$_temp(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ab3d7e6c3ad6ea9c$export$8ab5c6f0105ebb52, {
        url: (0, $cqmCC.ATLASSIAN_SUPPORT_URL),
        chunks: chunks,
        analyticsName: "supportLink"
    });
}
const $ab3d7e6c3ad6ea9c$export$8ab5c6f0105ebb52 = (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { url: url, chunks: chunks, analyticsName: analyticsName } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== analyticsName || $[1] !== createAnalyticsEvent) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "link",
                    actionSubjectId: analyticsName,
                    source: "errorDetail"
                }
            }).fire();
        };
        $[0] = analyticsName;
        $[1] = createAnalyticsEvent;
        $[2] = t1;
    } else t1 = $[2];
    const fireClickAnalytics = t1;
    let t2;
    if ($[3] !== chunks || $[4] !== fireClickAnalytics || $[5] !== url) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: url,
            target: "_blank",
            onClick: fireClickAnalytics
        }, chunks);
        $[3] = chunks;
        $[4] = fireClickAnalytics;
        $[5] = url;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};
module.exports["ErrorDetail"] = $ab3d7e6c3ad6ea9c$export$1b15b3abeb74ae7c;

});

parcelRegister("i1t43", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $w6R6I = parcelRequire("w6R6I");


var $iDrrr = parcelRequire("iDrrr");


var $7vK9E = parcelRequire("7vK9E");

var $iMnC5 = parcelRequire("iMnC5");

const $7e44050607850249$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    defaultAppearanceMotion: "_4bfu1r31 _1hms8stv _ajmmnqa1 _v564hxmd _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1j28 _1bnx8stv _jf4cnqa1 _30l313af _1nrm1j28 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    subtleAppearanceMotion: "_4bfu1j28 _1hms8stv _ajmmnqa1 _v564hxmd _syazazsu _1a3b1j28 _4fpr8stv _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    inverseAppearanceMotion: "_4bfu1r31 _1hms8stv _ajmmnqa1 _v564hxmd _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1j28 _1bnx8stv _jf4cnqa1 _30l315cr _1nrm1j28 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $7e44050607850249$var$iconStyles = null;
const $7e44050607850249$var$LinkWithoutRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(21);
    let children;
    let htmlAttributes;
    let newWindowLabel;
    let t1;
    let target;
    let testId;
    if ($[0] !== t0) {
        const { children: t2, testId: t3, appearance: t4, newWindowLabel: t5, target: t6, className: _preventedClassName, style: _preventedStyle, ...t7 } = t0;
        children = t2;
        testId = t3;
        t1 = t4;
        newWindowLabel = t5;
        target = t6;
        htmlAttributes = t7;
        $[0] = t0;
        $[1] = children;
        $[2] = htmlAttributes;
        $[3] = newWindowLabel;
        $[4] = t1;
        $[5] = target;
        $[6] = testId;
    } else {
        children = $[1];
        htmlAttributes = $[2];
        newWindowLabel = $[3];
        t1 = $[4];
        target = $[5];
        testId = $[6];
    }
    const appearance = t1 === undefined ? "default" : t1;
    let t2;
    if ($[7] !== appearance) {
        t2 = (0, $w6R6I.cx)($7e44050607850249$var$styles.base, (0, $iDrrr.fg)("platform-dst-shape-theme-default") && $7e44050607850249$var$styles.baseT26Shape, appearance === "default" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.defaultAppearanceMotion : $7e44050607850249$var$styles.defaultAppearance), appearance === "subtle" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.subtleAppearanceMotion : $7e44050607850249$var$styles.subtleAppearance), appearance === "inverse" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.inverseAppearanceMotion : $7e44050607850249$var$styles.inverseAppearance), appearance !== "inverse" && $7e44050607850249$var$styles.visitedLink);
        $[7] = appearance;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== target || $[10] !== testId) {
        t3 = target === "_blank" && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            as: "span",
            xcss: $7e44050607850249$var$styles.iconWrapper,
            testId: testId && `${testId}__icon`
        }, "\uFEFF", /*#__PURE__*/ $cozmU.createElement("svg", {
            width: "12",
            height: "12",
            viewBox: "0 0 12 12",
            fill: "none",
            className: (0, $hekY6.default)([
                "_1bsbgm0b _4t3igm0b _ahbqzjw7"
            ])
        }, /*#__PURE__*/ $cozmU.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
            fill: "currentColor"
        })));
        $[9] = target;
        $[10] = testId;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== children || $[13] !== htmlAttributes || $[14] !== newWindowLabel || $[15] !== ref || $[16] !== t2 || $[17] !== t3 || $[18] !== target || $[19] !== testId) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.default), {
            ...htmlAttributes,
            target: target,
            ref: ref,
            xcss: t2,
            testId: testId,
            componentName: "Link",
            newWindowLabel: newWindowLabel
        }, children, t3);
        $[12] = children;
        $[13] = htmlAttributes;
        $[14] = newWindowLabel;
        $[15] = ref;
        $[16] = t2;
        $[17] = t3;
        $[18] = target;
        $[19] = testId;
        $[20] = t4;
    } else t4 = $[20];
    return t4;
} : ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $w6R6I.cx)($7e44050607850249$var$styles.base, (0, $iDrrr.fg)('platform-dst-shape-theme-default') && $7e44050607850249$var$styles.baseT26Shape, appearance === 'default' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.defaultAppearanceMotion : $7e44050607850249$var$styles.defaultAppearance), appearance === 'subtle' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.subtleAppearanceMotion : $7e44050607850249$var$styles.subtleAppearance), appearance === 'inverse' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.inverseAppearanceMotion : $7e44050607850249$var$styles.inverseAppearance), // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $7e44050607850249$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }, children, target === '_blank' && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        as: "span",
        xcss: $7e44050607850249$var$styles.iconWrapper,
        testId: testId && `${testId}__icon`
    }, "\uFEFF", /*#__PURE__*/ $cozmU.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $hekY6.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    }))));
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $7e44050607850249$var$Link = /*#__PURE__*/ (0, $cozmU.forwardRef)($7e44050607850249$var$LinkWithoutRef);
var $7e44050607850249$export$2e2bcd8739ae039 = $7e44050607850249$var$Link;
module.exports["default"] = $7e44050607850249$export$2e2bcd8739ae039;

});

parcelRegister("cqmCC", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $jiJCD = parcelRequire("jiJCD");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");

const $1805b22ab5ce9c71$export$98c2bfe563916273 = 'https://support.atlassian.com/contact/#/';
const $1805b22ab5ce9c71$var$getLinkText = (showHostname)=>showHostname ? (0, $jiJCD.parse)($1805b22ab5ce9c71$export$98c2bfe563916273).hostname : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "error-boundary.description.support-link",
        defaultMessage: "Atlassian Support"
    });
const $1805b22ab5ce9c71$export$f1bb9e069c7d2c = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { showHostname: showHostname, children: children } = t0;
    let t1;
    if ($[0] !== children || $[1] !== showHostname) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) ? children : $1805b22ab5ce9c71$var$getLinkText(showHostname);
        $[0] = children;
        $[1] = showHostname;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: $1805b22ab5ce9c71$export$98c2bfe563916273,
            target: "_blank"
        }, t1);
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
module.exports["ATLASSIAN_SUPPORT_URL"] = $1805b22ab5ce9c71$export$98c2bfe563916273;
module.exports["AtlassianSupportLink"] = $1805b22ab5ce9c71$export$f1bb9e069c7d2c;

});

parcelRegister("d5QxR", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $azTKI = parcelRequire("azTKI");


var $fHs3z = parcelRequire("fHs3z");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $9DHhW = parcelRequire("9DHhW");

const $da843bad7fe75e8b$var$wrapperStyles = (0, $buxP3.xcss)({
    width: '100%',
    position: 'relative'
});
const $da843bad7fe75e8b$var$copyButtonStyles = (0, $buxP3.xcss)({
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    padding: 'space.050',
    zIndex: 'flag'
});
const $da843bad7fe75e8b$var$i18n = (0, $kSwu1.defineMessages)({
    copyTooltip: {
        id: "error-boundary.code-block.copy.tooltip",
        defaultMessage: "Copy"
    },
    copySuccess: {
        id: "error-boundary.code-block.copy.success",
        defaultMessage: "Copied!"
    },
    copyFailure: {
        id: "error-boundary.code-block.copy.failure",
        defaultMessage: "Copy to clipboard failed"
    }
});
const $da843bad7fe75e8b$export$ced1fc74d907d387 = (t0)=>{
    const $ = (0, $bDgLe.c)(34);
    const { lines: lines, analyticsSource: analyticsSource } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== intl) {
        t1 = intl.formatMessage($da843bad7fe75e8b$var$i18n.copyTooltip);
        $[0] = intl;
        $[1] = t1;
    } else t1 = $[1];
    const [tooltipMessage, setTooltipMessage] = (0, $cozmU.useState)(t1);
    const [justCopied, setJustCopied] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t2;
    if ($[2] !== lines) {
        t2 = Array.isArray(lines) && lines.every($da843bad7fe75e8b$var$_temp);
        $[2] = lines;
        $[3] = t2;
    } else t2 = $[3];
    const isValidLines = t2;
    let t3;
    if ($[4] !== isValidLines || $[5] !== lines) {
        t3 = isValidLines ? lines.join("\n") : "";
        $[4] = isValidLines;
        $[5] = lines;
        $[6] = t3;
    } else t3 = $[6];
    const source = t3;
    let t4;
    if ($[7] !== analyticsSource || $[8] !== createAnalyticsEvent || $[9] !== intl || $[10] !== source) {
        t4 = async ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "codeBlockCopyToClipboard",
                    source: analyticsSource
                }
            }).fire();
            try {
                await navigator.clipboard.writeText(source);
                setTooltipMessage(intl.formatMessage($da843bad7fe75e8b$var$i18n.copySuccess));
                setJustCopied(true);
            } catch (t5) {
                setTooltipMessage(intl.formatMessage($da843bad7fe75e8b$var$i18n.copyFailure));
            }
        };
        $[7] = analyticsSource;
        $[8] = createAnalyticsEvent;
        $[9] = intl;
        $[10] = source;
        $[11] = t4;
    } else t4 = $[11];
    const writeToClipboard = t4;
    let t5;
    if ($[12] !== intl || $[13] !== justCopied) {
        t5 = ()=>{
            if (!justCopied) setTooltipMessage(intl.formatMessage($da843bad7fe75e8b$var$i18n.copyTooltip));
        };
        $[12] = intl;
        $[13] = justCopied;
        $[14] = t5;
    } else t5 = $[14];
    const resetTooltipMessage = t5;
    let t6;
    if ($[15] !== resetTooltipMessage) {
        t6 = ()=>{
            setJustCopied(false);
            resetTooltipMessage();
        };
        $[15] = resetTooltipMessage;
        $[16] = t6;
    } else t6 = $[16];
    const handleBlur = t6;
    let t7;
    if ($[17] !== justCopied || $[18] !== resetTooltipMessage) {
        t7 = ()=>{
            if (!justCopied) resetTooltipMessage();
        };
        $[17] = justCopied;
        $[18] = resetTooltipMessage;
        $[19] = t7;
    } else t7 = $[19];
    const handleMouseOver = t7;
    let t8;
    if ($[20] !== resetTooltipMessage) {
        t8 = ()=>{
            setJustCopied(false);
            resetTooltipMessage();
        };
        $[20] = resetTooltipMessage;
        $[21] = t8;
    } else t8 = $[21];
    const handleMouseLeave = t8;
    let t9;
    if ($[22] !== handleBlur || $[23] !== handleMouseLeave || $[24] !== handleMouseOver || $[25] !== resetTooltipMessage || $[26] !== tooltipMessage || $[27] !== writeToClipboard) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $da843bad7fe75e8b$var$copyButtonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            isTooltipDisabled: false,
            label: tooltipMessage,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))),
            onClick: writeToClipboard,
            onMouseOver: handleMouseOver,
            onMouseLeave: handleMouseLeave,
            onFocus: resetTooltipMessage,
            onBlur: handleBlur,
            "aria-live": "assertive",
            "aria-atomic": "true",
            appearance: "subtle",
            spacing: "compact"
        }));
        $[22] = handleBlur;
        $[23] = handleMouseLeave;
        $[24] = handleMouseOver;
        $[25] = resetTooltipMessage;
        $[26] = tooltipMessage;
        $[27] = writeToClipboard;
        $[28] = t9;
    } else t9 = $[28];
    let t10;
    if ($[29] !== source) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $azTKI.default), {
            text: source,
            showLineNumbers: false,
            shouldWrapLongLines: false
        }));
        $[29] = source;
        $[30] = t10;
    } else t10 = $[30];
    let t11;
    if ($[31] !== t10 || $[32] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $da843bad7fe75e8b$var$wrapperStyles,
            role: "region"
        }, t9, t10);
        $[31] = t10;
        $[32] = t9;
        $[33] = t11;
    } else t11 = $[33];
    return t11;
};
function $da843bad7fe75e8b$var$_temp(line) {
    return typeof line === "string";
}
module.exports["CodeBlockWithCopyButton"] = $da843bad7fe75e8b$export$ced1fc74d907d387;

});

parcelRegister("iGOxg", function(module, exports) {
module.exports = new URL("SearchErrorImage.5b33bcd4.svg", import.meta.url).toString();

});

parcelRegister("jln20", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $lRhY3 = parcelRequire("lRhY3");


var $87whh = parcelRequire("87whh");


var $aWwYt = parcelRequire("aWwYt");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = ()=>{
    return (0, $cozmU.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
};
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [sidebars, setSidebars] = (0, $cozmU.useState)(t1);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $cozmU.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $lRhY3.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $87whh.useIsPreviewPanelOpen)();
    let t2;
    if ($[1] !== hideObjectSidebar || $[2] !== hidePreviewPanel || $[3] !== isPreviewPanelOpen || $[4] !== sidebars || $[5] !== triggerButtonRef) {
        t2 = $8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        });
        $[1] = hideObjectSidebar;
        $[2] = hidePreviewPanel;
        $[3] = isPreviewPanelOpen;
        $[4] = sidebars;
        $[5] = triggerButtonRef;
        $[6] = t2;
    } else t2 = $[6];
    const contextValue = t2;
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const handleCloseGlobalSidebar = ()=>{
                if ((0, $9wGTI.fg)("forge-ui-fix-forge-confluence-mainlayout-rerender")) setSidebars($8facebd0ecb5e0ee$var$_temp);
                else setSidebars([]);
            };
            window.addEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            return ()=>{
                window.removeEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            };
        };
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[9] !== children || $[10] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
function $8facebd0ecb5e0ee$var$_temp(prev) {
    return prev.length === 0 ? prev : [];
}
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("87whh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $3Ap09 = parcelRequire("3Ap09");

const $5fad2268a70a3d3b$export$c68e55e6e77f3d5d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (panelId)=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
} : (panelId)=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5fad2268a70a3d3b$export$c68e55e6e77f3d5d;

});

parcelRegister("hGNbF", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");

parcelRequire("3jLHL");
var $fXXXK = parcelRequire("fXXXK");


var $fp2Bc = parcelRequire("fp2Bc");


var $gE1ec = parcelRequire("gE1ec");


var $lxV8r = parcelRequire("lxV8r");


var $cozmU = parcelRequire("cozmU");


var $ifF9E = parcelRequire("ifF9E");

var $ce0c8371df0bdae0$var$isDevelopment = false;
var $ce0c8371df0bdae0$var$testOmitPropsOnStringTag = (0, $ifF9E.default);
var $ce0c8371df0bdae0$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $ce0c8371df0bdae0$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $ce0c8371df0bdae0$var$testOmitPropsOnStringTag : $ce0c8371df0bdae0$var$testOmitPropsOnComponent;
};
var $ce0c8371df0bdae0$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $ce0c8371df0bdae0$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $lxV8r.registerStyles)(cache, serialized, isStringTag);
    (0, $gE1ec.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $lxV8r.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $ce0c8371df0bdae0$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $ce0c8371df0bdae0$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $ce0c8371df0bdae0$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $fXXXK.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $cozmU.useContext((0, $fXXXK.T));
            }
            if (typeof props.className === 'string') className = (0, $lxV8r.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $fp2Bc.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $ce0c8371df0bdae0$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement($ce0c8371df0bdae0$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $cozmU.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $ce0c8371df0bdae0$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $eb3ax.default)({}, options, nextOptions, {
                shouldForwardProp: $ce0c8371df0bdae0$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};
module.exports["default"] = $ce0c8371df0bdae0$export$2e2bcd8739ae039;

});

parcelRegister("3jLHL", function(module, exports) {
$parcel$export(module.exports, "jsx", () => $26a826a6de57547f$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("fXXXK")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("fXXXK")).w);

var $fXXXK = parcelRequire("fXXXK");


var $cozmU = parcelRequire("cozmU");


var $lxV8r = parcelRequire("lxV8r");


var $gE1ec = parcelRequire("gE1ec");


var $fp2Bc = parcelRequire("fp2Bc");

parcelRequire("e7SVr");

parcelRequire("eb3ax");

parcelRequire("doWRd");


parcelRequire("aH9xZ");

var $26a826a6de57547f$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $fXXXK.h).call(props, 'css')) return $cozmU.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $fXXXK.E);
    createElementArgArray[1] = (0, $fXXXK.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $cozmU.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($26a826a6de57547f$export$c8a8987d4410bf2d || ($26a826a6de57547f$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $26a826a6de57547f$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $fXXXK.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $fp2Bc.serializeStyles)([
        styles
    ], undefined, $cozmU.useContext((0, $fXXXK.T)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $cozmU.useRef();
    (0, $gE1ec.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $gE1ec.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $lxV8r.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $26a826a6de57547f$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $fp2Bc.serializeStyles)(args);
}
function $26a826a6de57547f$export$d25ddfdf17c3ad3e() {
    var insertable = $26a826a6de57547f$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $26a826a6de57547f$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $26a826a6de57547f$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $lxV8r.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $26a826a6de57547f$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $gE1ec.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $lxV8r.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $26a826a6de57547f$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $fXXXK.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $fXXXK.i)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $fp2Bc.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $lxV8r.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $fXXXK.i)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $26a826a6de57547f$var$merge(cache.registered, css, $26a826a6de57547f$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $cozmU.useContext((0, $fXXXK.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement($26a826a6de57547f$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
module.exports["Global"] = $26a826a6de57547f$export$98f03c5d19621d70;
module.exports["css"] = $26a826a6de57547f$export$dbf350e5966cf602;
module.exports["keyframes"] = $26a826a6de57547f$export$d25ddfdf17c3ad3e;

});

parcelRegister("gE1ec", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

var $c1e155a1b94f67fa$var$syncFallback = function syncFallback(create) {
    return create();
};
var $c1e155a1b94f67fa$var$useInsertionEffect = $cozmU.useInsertionEffect ? $cozmU.useInsertionEffect : false;
var $c1e155a1b94f67fa$export$db21c7ffa21794e7 = $c1e155a1b94f67fa$var$useInsertionEffect || $c1e155a1b94f67fa$var$syncFallback;
var $c1e155a1b94f67fa$export$811a713a7276cb9d = $c1e155a1b94f67fa$var$useInsertionEffect || $cozmU.useLayoutEffect;
module.exports["useInsertionEffectAlwaysWithSyncFallback"] = $c1e155a1b94f67fa$export$db21c7ffa21794e7;
module.exports["useInsertionEffectWithLayoutFallback"] = $c1e155a1b94f67fa$export$811a713a7276cb9d;

});

parcelRegister("ifF9E", function(module, exports) {

var $e8eWN = parcelRequire("e8eWN");

// eslint-disable-next-line no-undef
var $d4998d3150d9a680$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $d4998d3150d9a680$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $e8eWN.default)(function(prop) {
    return $d4998d3150d9a680$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
module.exports["default"] = $d4998d3150d9a680$export$2e2bcd8739ae039;

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $abc73c6f5c74c436$var$useRouterLink = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $abc73c6f5c74c436$export$2e2bcd8739ae039 = $abc73c6f5c74c436$var$useRouterLink;
module.exports["default"] = $abc73c6f5c74c436$export$2e2bcd8739ae039;

});

parcelRegister("ac2J9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1
        }, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("8Xus6", function(module, exports) {
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $cfd109792a890cba$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'TOML',
        alias: [
            'toml'
        ],
        value: 'toml'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    },
    {
        name: 'Markdown',
        alias: [
            'markdown'
        ],
        value: 'markdown'
    }
];
module.exports["SUPPORTED_LANGUAGES"] = $cfd109792a890cba$export$7c77c3a9bb93870d;

});

parcelRegister("c8XQL", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $lOiVq = parcelRequire("lOiVq");


var $fp2Bc = parcelRequire("fp2Bc");


var $gE1ec = parcelRequire("gE1ec");


var $lxV8r = parcelRequire("lxV8r");


var $cozmU = parcelRequire("cozmU");


var $ifF9E = parcelRequire("ifF9E");

var $8d74a858e0464007$var$isDevelopment = false;
var $8d74a858e0464007$var$testOmitPropsOnStringTag = (0, $ifF9E.default);
var $8d74a858e0464007$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $8d74a858e0464007$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $8d74a858e0464007$var$testOmitPropsOnStringTag : $8d74a858e0464007$var$testOmitPropsOnComponent;
};
var $8d74a858e0464007$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $8d74a858e0464007$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $lxV8r.registerStyles)(cache, serialized, isStringTag);
    (0, $gE1ec.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $lxV8r.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $8d74a858e0464007$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $8d74a858e0464007$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $8d74a858e0464007$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $lOiVq.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $cozmU.useContext((0, $lOiVq.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, $lxV8r.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $fp2Bc.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $8d74a858e0464007$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement($8d74a858e0464007$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $cozmU.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $8d74a858e0464007$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $eb3ax.default)({}, options, nextOptions, {
                shouldForwardProp: $8d74a858e0464007$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};
module.exports["default"] = $8d74a858e0464007$export$2e2bcd8739ae039;

});


//# sourceMappingURL=Home.0a3bf305.js.map
